module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../node_modules/coffee-loader/index.js!./vi.coffee"));
	}, "vi");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=[name]!./app/locale/vi.coffee
// module id = 244
// module chunks = 97